module.exports = __webpack_public_path__ + "img/facebook-icon.3a7f2232.svg";